const $ = window.jQuery;
import { getBaseURL } from '@vue/store/helpers.js';


window.RW_LOC_FORM = {
  data: {
    isResearchCenter: ( window.location.pathname.indexOf('/research') == 0 ),
    isHome: ( window.location.pathname == '/' ),
    placeholderText: '',
    requestURL: '',
    imWarningText: 'Please start typing in the search field and make a selection to start searching for investment properties',
    pmWarningText: 'Please start typing in the search field and make a selection to tell us where you are looking for hassle free property management services.',
    warningText: '',
    query: '',
    actionType: 'frpa'
  },
  selectors: {
    locationSearch: '#location-search',
    form: '#location-search-form',
    searchField: '.select2-search__field',
    locationFormActionInputs: '.location-form-action-input'
  },
  init: function(){
        
    if(this.data.isResearchCenter){
      this.setDataProperty({placeholderText: 'Enter a County'});
      this.setDataProperty({requestURL: this.getBaseURL() + '/researchAjax'});
    } else {
      this.setDataProperty({placeholderText: 'Enter a City, County or Zip Code'});
      this.setDataProperty({requestURL: this.getBaseURL() + '/api/getSearchLocations'});
    }

    if(this.data.isHome) {
      this.setDataProperty({warningText: this.data.pmWarningText});
    } else {
      this.setDataProperty({warningText: this.data.imWarningText});
    }
        
    this.initEvents();
  },
  initEvents: function(){
    var self = this;
    $(document).ready(function(){

      // On Location Form Subnmit
            
      $(self.selectors.form).on('submit', function(evt){

        // If no selection has been made
        if(!$(self.selectors.locationSearch).val()){
                    
          // if we are on the home page
          if(self.data.isHome && self.data.actionType == 'frpa'){
                        
            // if the user has typed into the search field
            if(self.data.query){

              evt.preventDefault();
              swal({
                title: 'Oops! Please make a selection',
                icon: 'warning',
                text: self.data.warningText
              });
              self.resetQuery();
                            
            } else {
                            
              // let the form submit event proceed
              return true;
            }

          } else {
            evt.preventDefault();
            swal({
              title: 'Oops! Invalid Search',
              icon: 'warning',
              text: self.data.warningText,
              timer: 10000,
            });

          }   
        }

      });

      // Every time a selection is made from the dropdown
      $(self.selectors.locationSearch).on('select2:select', function(e){
        var data = e.params.data;
        window.dataLayer.push({locationSearchSelection: data.text});

        /* If the item selected starts with 'mls', we knbow it is a listing and we should redirect to its listng page */
        if(data.id && data.id.indexOf('mls-') === 0) {
          var hashParts = data.id.split('-');
          var listingHash = hashParts[1];
          window.location.replace('/listing/' + listingHash);
          return false;
        }
                
      });

      // Every time an option is un-selected
      $(self.selectors.locationSearch).on('select2:unselect', function(e){
        self.resetQuery();
      });

      // Every time the input in the serarch field changes
      $(document).on('change', '.select2-search__field', function(e){
        if(!e.target.value) return false;
        window.dataLayer.push({locationSearchTerm: e.target.value});

        // store the query in our object, the search field disappears on form submit and field blur, so we need to keep track of it
        self.setDataProperty({query: e.target.value});
      });

      var locationSearchConfig = {
        placeholder: self.data.placeholderText,
        allowClear: true,
        ajax: {
          type: 'GET',
          delay: 500,
          url: self.data.requestURL,
          dataType: 'json',
          language: {
            noResults: function () {
              return 'That\'s a miss.';
            }
          },
          escapeMarkup: function (markup) {
            return markup;
          },
          data: function (params) {
            let data = {
              term: params.term
            };
            if(self.data.isResearchCenter) {
              data.ignore_states = true;
            }
            return data;
          },
          processResults: function (data) {
            return data;
          },
          error: function () {
            return {results: []};
          }
        },
        minimumInputLength: 2,
        templateResult: self.formatResults,
      };

      // Init Select2 on the Location Search dropdown
      $(self.selectors.locationSearch).select2(locationSearchConfig);

      // We are on the home page
      if(self.data.isHome){
        if($(self.selectors.searchField).val() && !$(self.selectors.locationSearch).val()){
          swal({
            title: 'Oops! Invalid Search',
            icon: 'warning',
            text: 'Please start typing in the search field to select a location to search for properties',
            timer: 10000,
          });
        }
                
      }


    });
  },
  getBaseURL: function(){
    return getBaseURL();
  },
  formatResults: function(result) {
    var newChildren = [];
    if(result.text == 'Zipcodes'){
      newChildren = result.children.map(function(child){
        return {
          id: 'zipcode-' + child.id,
          text: child.id + ' - ' + child.text
        };
      });
      result.text = $('<div class="rw-select2-group-wrapper">' + result.text + '</div>');
      result.children = newChildren;
    } else if(result.text == 'Listings'){
      newChildren = result.children.map(function(child){
        return {
          id: 'mls-' + child.id,
          text: child.text + ' (' + child.mls.toUpperCase() + ')'
        };
      });
      result.text = $('<div class="rw-select2-group-wrapper">MLS Properties</div>');
      result.children = newChildren;
    } else if(
      result.text == 'States' ||
      result.text == 'Counties' ||
      result.text == 'Markets' ||
      result.text == 'Cities'
    ) {
      var prefix = '';
      switch(result.text) {
      case 'States':
        prefix = 'state';
        break;
      case 'Counties':
        prefix = 'county';
        break;
      case 'Markets':
        prefix = 'market';
        break;
      case 'Cities':
        prefix = 'city';
        break;
      }
      newChildren = result.children.map(function(child){

        let id = prefix + '-' + child.id;
        // `this` is undefined in this function
        if(window.RW_LOC_FORM.data.isResearchCenter) id = prefix + '_' + child.slug;

        return {
          id,
          text: child.text
        };
      });
      result.text = $('<div class="rw-select2-group-wrapper">' + result.text + '</div>');
      result.children = newChildren;
    }
    return result.text;
  },
  resetQuery: function(){
    this.setDataProperty({query: ''});
  },
  setDataProperty: function(args){
    if(!Object.keys(args)) {
      console.error('setData :: invalid args');
      return false;
    }
    var key = Object.keys(args)[0];
    var value = Object.values(args)[0];
    this.data[key] = value;
  },
};


window.RW_LOC_FORM.init();